<template>
	<footer class="private-footer-new" v-if="!hideFooter">
		<div class="footer-bottom">
			<div class="row">
				<div class="col-lg-5">
					<img src="@/assets/images/logo-hts-footer.png" style="height: 24px;"/>
          <div class="footer-info">
  					<div class="footer-company font-sanpro-semibold">
  						Nhà xuất bản Giáo dục Việt Nam
  					</div>
  					<div class="footer-text">
  						Địa chỉ: Số 81 Trần Hưng Đạo, Hoàn Kiếm, Hà Nội
  					</div>
  					<div class="footer-text">
  						Điện thoại: 024.38220801 - Fax: 024.39422010
  					</div>
          </div>
          <div class="footer-info">
            <div class="footer-company font-sanpro-semibold">
              Bộ phận hỗ trợ kỹ thuật nền tảng Hành trang số
            </div>
            <div class="footer-text">
              Điện thoại: 079 319 9779 (08:00 - 17:00 T2 - T6)
            </div>
            <div class="footer-text">
              Email: hotro.hts@aesgroup.edu.vn
            </div>
          </div>
				</div>
				<div class="col-lg-7">
					<div class="footer-menu-wrap">
						<div class="footer-menu-help">
							<ul class="ul-footer margin-0 p-0 justify-content-xl-end">
								<li><router-link :to="{name: 'page-about'}" class="title-ft">Giới thiệu</router-link></li>
								<li><router-link :to="{name: 'under-construction'}" class="title-ft">Chính sách bảo mật</router-link></li>	
								<li><router-link :to="{name: 'guide-page'}" class="title-ft">Hướng dẫn sử dụng</router-link></li>	
								<li><router-link :to="{name: 'under-construction'}" class="title-ft">Trung tâm trợ giúp</router-link></li>
							</ul>
						</div>
						<div class="mt-2">
							<ul class="ul-footer ul-social margin-0 p-0 justify-content-xl-end">
								<li>
									<a title="Fanpage Hành trang số" href="https://www.facebook.com/Hanhtrangso/" target="_blank" class="primary-color">
                   <i class="icon-facebook footer-icon-facebk font-size-24"></i>
                  </a>&nbsp;
								</li>
								<li>
									<!-- <a href="mailto:hotro.hts@aesgroup.edu.vn" class="primary-color">
										<i class="icon-email font-size-24 primary-color"></i>
									</a> -->
									<a title="Kênh Youtube Hành trang số" href="https://www.youtube.com/c/H%C3%A0nhTrangS%E1%BB%91/featured" target="_blank" class="primary-color">
										<i class="icon-youtube font-size-24 primary-color"></i>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>		
			<div class="row">
				<div class="col-12">
					<hr/>
				</div>
			</div>			
			<div class="row">
				<div class="col-12 footer-text">
					© Copyright 2020 Hành trang số - Nhà xuất bản Giáo dục Việt Nam
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		name: 'Footer',
		data() {
			return {
				hideFooter: false
			};
		},
		watch: {
			'$route': 'checkDisplayFooter'
		},
		created() {
			this.checkDisplayFooter();
		},
		methods: {
			checkDisplayFooter() {
				// console.log( this.$router.history.current.meta.hideFooter);
				this.hideFooter = this.$router.history.current.meta.hideFooter ? true : false;
			}
		}
	};
</script>

<style lang="scss" scoped>
.ul-footer li{
	list-style-type: none;
	display: initial!important;
    color: #124abe;
    font-size: 14px;
    // line-height: 50px;
    font-weight: bold;
}
.ul-footer li .title-ft{
	color: #124abe !important;
	&:hover{
		color: #003096 !important;
	}
}
.footer-menu-help ul li:not(:last-child) {
    margin-right: 20px;
}
.ul-social {
	li {
		&:not(:last-child) {
			margin-right: 10px;
		}
	}
}
p.private-footer-new-p {
	font-size: 14px;
	color:#879AA9;
}
.footer-company{
	font-size: 14px;
	color: #40505E;
	margin-top: 10px;
}
.footer-text{
	font-size: 13px;
	color: #879AA9;
}
.footer-hr{
	margin-top: 15px;
    margin-bottom: 10px;
    border: 0;
    border-top: 2px solid rgba(0, 0, 0, 0.1);
}
@media screen and (max-width: 991px) {
	.footer-menu-wrap {
		display: flex;

		.footer-menu-help {
			width: calc(100% - 60px)
		}

		.ul-social {
			width: 60px;
		}
	}
}
@media screen and (max-width: 360px) {
	.footer-menu-help {
		ul {
			li:not(:last-child) {
				margin-right: 11px;
			}
		}
	}
}
</style>